"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  number: "150K+",
  label: "Giao dịch thành công"
}, {
  number: "50K+",
  label: "Game thủ tin dùng"
}, {
  number: "99.9%",
  label: "Tỷ lệ hài lòng"
}, {
  number: "24/7",
  label: "Hỗ trợ trực tuyến"
}];
export default function OurRescueImpact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}